
export default {
  created () {
    this.$store.dispatch('setCode', [])
    this.$emit('changePlayer', 'n-player')
  }
}